import React, { useEffect, useState } from "react";
import "./LeaveSummary.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { format, addDays, subDays } from "date-fns";
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";

ChartJS.register(ArcElement, Tooltip, Legend);

const LeaveSummary = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  // Initialize current date
  const [currentDate, setCurrentDate] = useState(new Date());

  const [attendanceData, setAttendanceData] = useState("");

  const [chartData, setChartData] = useState(null);

  // Function to go to the previous day
  const handlePrevDate = () => {
    setCurrentDate((prevDate) => subDays(prevDate, 1));
  };

  // Function to go to the next day
  const handleNextDate = () => {
    setCurrentDate((prevDate) => addDays(prevDate, 1));
  };

  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  const options = {
    cutoutPercentage: 50, // Adjust the cutout percentage to create a donut chart
    cutout: "80%",
    plugins: {
      legend: {
        display: false, // Hide default legend
      },
    },
  };

  const fetchLeaveData = async () => {
    const apiDate = format(currentDate, "yyyy-MM-dd");

    const apiUrl = `${base_url}api/HRDashboard/${companyCode}/-/LEAVECOUNT/${apiDate}/${apiDate}/-/-/-/-/-`;

    console.log("apiUrl-AttendanceAnalysis", apiUrl);

    try {
      const response = await axios.get(apiUrl);
      if (response.status === 200) {
        const apiData = response.data;

        // Map API data to labels and dataset values
        const labels = apiData.map((item) => item.leave_key);
        const dataValues = apiData.map((item) => item.count);

        // Update chart data
        setChartData({
          labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: [
                // "#003f5c",
                // "#58508d",
                // "#bc5090",
                // "#ff6361",
                // "#ffa600",
                '#3B82F6',
                '#A855F7',
                '#EAB308',
                '#EF4444',
                '#22C55E',
            ],
            hoverBackgroundColor: [
                  '#3B82F6',
                  '#A855F7',
                  '#EAB308',
                  '#EF4444',
                  '#22C55E',
                // "#003f5c",
                // "#58508d",
                // "#bc5090",
                // "#ff6361",
                // "#ffa600",
              ],
            },
          ],
        });
        setAttendanceData(response.data);
      }
    } catch (error) {
      console.error("Error fetchLeaveData:", error);
    }
  };

  useEffect(() => {
    if (base_url) {
      fetchLeaveData();
    }
  }, [currentDate, base_url]);

  // console.log("attendanceData", attendanceData);
  // console.log("chartData", chartData);

  return (
    <div className="flex flex-col items-center justify-center rounded-[20px] p-2">
      <div className="mt-[16px] sm:mt-0">
        <div className="text-[14px] font-bold text-black mb-2">
          Attendance Analysis
        </div>
        <div className="AADateToggle flex items-center gap-2">
          <span className="cursor-pointer" onClick={handlePrevDate}>
            <MdOutlineKeyboardArrowLeft />
          </span>
          <div className="text-[12px] font-normal">
            {format(currentDate, "dd MMM yyyy")}
          </div>
          <span className="cursor-pointer" onClick={handleNextDate}>
            <MdOutlineKeyboardArrowRight />
          </span>
        </div>
      </div>

      {!chartData && (
        <div className="text-center text-red-600">No Data Available</div>
      )}

      <div className="flex justify-center items-center h-[244px] w-full gap-[20px]">
        {chartData && (
          <div className="flex justify-center w-[200px] h-[200px] max-[460px]:w-[100px] max-[460px]:h-[100px]">
            <Doughnut data={chartData} options={options} />
          </div>
        )}

        <div className="flex flex-col justify-center h-40 w-[45%] pl-[20px] border-l border-[#ddd] ">
  {chartData &&
    chartData.labels.map((label, index) => (
      <div
        key={index}
        className="flex items-center mb-[6px] text-[12px] max-[460px]:text-[12px]"
      >
        <span
          className="w-[12px] h-[12px] mr-[10px] rounded-full"
          style={{
            backgroundColor: chartData.datasets[0].backgroundColor[index],
          }}
        ></span>
        <span className="mr-2 font-semibold ">{label}:
         <span className="font-semibold ml-2">
          ({chartData.datasets[0].data[index]})</span>
        </span> 
      </div>
    ))}
</div>

      </div>
    </div>
  );
};

export default LeaveSummary;
